import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

import { defaultAvatarUrl } from '@/config/constants';

import useMeQuery from '@/api/queries/me/useMeQuery';

export const useAvatarStore = defineStore('avatar', () => {
  const { auth } = useMeQuery();

  const isAvatarLoading = ref(false);

  const isDefaultAvatar = computed(() => auth.value?.branding?.avatar === defaultAvatarUrl);

  return {
    isAvatarLoading,
    isDefaultAvatar,
  };
});
